import { render, staticRenderFns } from "./Verificode.vue?vue&type=template&id=25edf8db&lang=pug"
import script from "./Verificode.vue?vue&type=script&lang=js"
export * from "./Verificode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports